export const apiKeyErrors: Record<string, string> = {
  API_KEY_SAME_NAME: 'apiKeyNameExists',
  INTERNAL_SERVER_ERROR: 'internalServerError',
};
